"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyNote = void 0;
const class_validator_1 = require("class-validator");
const file_1 = require("./sub-models/general/file");
class CompanyNote {
    constructor(fields) {
        this.userId = ''; // User who created the note
        this.date = null;
        this.comment = '';
        this.files = [];
        // Task-specific fields
        this.taskType = 'log'; // 'møde', 'efterårshilsen', 'julehilsen', 'overførsler', 'log indlæg', etc.
        this.title = ''; // Short title for tasks
        this.deadline = null; // Deadline for tasks
        this.status = ''; // Task status
        this.responsibleUserId = ''; // User responsible for the task
        this.completedAt = null; // When task was completed
        this.completedBy = ''; // Who completed the task
        for (let [key, value] of Object.entries(fields)) {
            switch (key) {
                case 'date':
                case 'deadline':
                case 'completedAt':
                case 'createdAt':
                case 'updatedAt':
                    if (value) {
                        if (value.hasOwnProperty('_seconds')) {
                            //Parse from timestamp to date
                            this[key] = new Date(value.toDate());
                        }
                        else {
                            this[key] = new Date(value);
                        }
                    }
                    break;
                case 'files':
                    this[key] = value.map(file => new file_1.File(file));
                    break;
                default:
                    this[key] = value;
                    break;
            }
        }
    }
    toJSONObject() {
        return {
            id: this.id,
            companyId: this.companyId,
            userId: this.userId,
            date: this.date,
            comment: this.comment,
            files: this.files.map(file => file.toJSONObject()),
            taskType: this.taskType,
            title: this.title,
            deadline: this.deadline,
            status: this.status,
            responsibleUserId: this.responsibleUserId,
            completedAt: this.completedAt,
            completedBy: this.completedBy,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        };
    }
    toDatabase() {
        return {
            companyId: this.companyId,
            userId: this.userId,
            date: this.date,
            comment: this.comment,
            files: this.files.map(file => file.toDatabase()),
            taskType: this.taskType,
            title: this.title,
            deadline: this.deadline,
            status: this.status,
            responsibleUserId: this.responsibleUserId,
            completedAt: this.completedAt,
            completedBy: this.completedBy,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        };
    }
    async isValid() {
        return await (0, class_validator_1.validate)(this).then((errors) => {
            if (errors.length > 0) {
                return errors;
            }
            else {
                return null;
            }
        });
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)()
], CompanyNote.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CompanyNote.prototype, "companyId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "comment", void 0);
__decorate([
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "files", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CompanyNote.prototype, "taskType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "deadline", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "responsibleUserId", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "completedAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], CompanyNote.prototype, "completedBy", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)()
], CompanyNote.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)()
], CompanyNote.prototype, "updatedAt", void 0);
exports.CompanyNote = CompanyNote;
